export function animatePromised(
  element: Animatable,
  keyframes: Keyframe[] | PropertyIndexedKeyframes | null,
  options?: number | KeyframeAnimationOptions | undefined,
): Promise<Animation> {
  // animate element (chrome > 70)
  const animation = element.animate(keyframes, options);

  // if the animation has a finished promise (chrome > 85) return it
  if (animation.finished && typeof animation.finished.then === 'function') {
    return animation.finished;
  }

  return new Promise((resolve) => {
    animation.onfinish = () => {
      resolve(animation);
    };
  });
}
